import BigNumber from 'bignumber.js'
import { SerializedNftPool } from 'state/types'
import { deserializeToken } from '@pancakeswap/token-lists'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { DeserializedNftPool } from '@pancakeswap/nft-pools'
import { isAddress } from 'utils'
import { Token } from '@pancakeswap/sdk'

type UserData =
  | DeserializedNftPool<Token>['userData']
  | {
      isApprovedForAll: boolean
      stakingNftBalance: string[]
      stakedNftBalance: string[]
      pendingReward: number | string
    }

export const transformUserData = (userData: UserData) => {
  return {
    isApprovedForAll: userData ? userData.isApprovedForAll : false,
    stakingNftBalance: userData ? (userData.stakingNftBalance ? userData.stakingNftBalance : []) : [],
    stakedNftBalance: userData ? (userData.stakedNftBalance ? userData.stakedNftBalance : []) : [],
    pendingReward: userData ? new BigNumber(userData.pendingReward) : BIG_ZERO,
  }
}

export const transformPool = (pool: SerializedNftPool): DeserializedNftPool<Token> => {
  const { totalStaked, stakingLimit, version, userData, stakingToken, earningToken, startTimestamp, ...rest } = pool

  return {
    ...rest,
    startTimestamp,
    stakingToken: deserializeToken(stakingToken),
    earningToken: deserializeToken(earningToken),
    version,
    userData: transformUserData(userData),
    totalStaked: new BigNumber(totalStaked),
    stakingLimit: new BigNumber(stakingLimit),
  }
}

export const getTokenPricesFromFarm = (
  farms: {
    quoteToken: { address: string }
    token: { address: string }
    quoteTokenPriceBusd: string
    tokenPriceBusd: string
  }[],
) => {
  return farms.reduce((prices, farm) => {
    const quoteTokenAddress = isAddress(farm.quoteToken.address)
    const tokenAddress = isAddress(farm.token.address)
    /* eslint-disable no-param-reassign */
    if (quoteTokenAddress && !prices[quoteTokenAddress]) {
      prices[quoteTokenAddress] = new BigNumber(farm.quoteTokenPriceBusd).toNumber()
    }
    if (tokenAddress && !prices[tokenAddress]) {
      prices[tokenAddress] = new BigNumber(farm.tokenPriceBusd).toNumber()
    }
    /* eslint-enable no-param-reassign */
    return prices
  }, {})
}
